import { useFeatureFlag, User } from 'configcat-react';

import type { FeatureFlagValue, SettingTypeOf } from '../types';
import type { ConfigCatFeatureFlagUserConfig } from './build-config-cat-user-profile';
import { buildConfigCatUserProfile } from './build-config-cat-user-profile';

export type { ConfigCatFeatureFlagUserConfig } from './build-config-cat-user-profile';

export function useConfigCatFeatureFlag<T extends FeatureFlagValue = false>(
  key: string,
  defaultValue: T = false as T,
  userConfig: ConfigCatFeatureFlagUserConfig = {},
): { value: SettingTypeOf<T>; loading: boolean } {
  const profile = buildConfigCatUserProfile(userConfig);
  const configCatUser = new User(profile.identifier, profile.email, undefined, profile.custom);

  return useFeatureFlag(key, defaultValue, configCatUser);
}
